import { HomeAPIPath, HomeType } from '@/enums';
import { getRoute } from '@/hooks/useRouteSection';

export const getAPIPath = () => {
  if (typeof window !== 'undefined') {
    const { productType } = getRoute(window.location.pathname);
    return {
      [HomeType.Hohh]: HomeAPIPath.Hohh,
      [HomeType.MyRumah]: HomeAPIPath.MyRumah,
    }[productType];
  }
};
